import alertIcon, { ReactComponent as alertSvg } from '../../../img/icon/alert-icon.svg';
import arrowIcon, { ReactComponent as arrowSvg } from '../../../img/icon/arrow-icon.svg';
import calendarIcon, { ReactComponent as calendarSvg } from '../../../img/icon/calendar-icon.svg';
import cardsIcon, { ReactComponent as cardsSvg } from '../../../img/icon/cards-icon.svg';
import checkIcon, { ReactComponent as checkSvg } from '../../../img/icon/check-icon.svg';
import clockIcon, { ReactComponent as clockSvg } from '../../../img/icon/clock-icon.svg';
import closeIcon, { ReactComponent as closeSvg } from '../../../img/icon/close-icon.svg';
import cogIcon, { ReactComponent as cogSvg } from '../../../img/icon/cog-icon.svg';
import correctIcon, { ReactComponent as correctSvg } from '../../../img/icon/correct-icon.svg';
import deleteIcon, { ReactComponent as deleteSvg } from '../../../img/icon/delete-icon.svg';
import downloadIcon, { ReactComponent as downloadSvg } from '../../../img/icon/download-icon.svg';
import editIcon, { ReactComponent as editSvg } from '../../../img/icon/edit-icon.svg';
import eyeIcon, { ReactComponent as eyeSvg } from '../../../img/icon/eye-icon.svg';
import fileIcon, { ReactComponent as fileSvg } from '../../../img/icon/file-icon.svg';
import filesIcon, { ReactComponent as filesSvg } from '../../../img/icon/files-icon.svg';
import filtersIcon, { ReactComponent as filtersSvg } from '../../../img/icon/filters-icon.svg';
import stopwatchIcon, { ReactComponent as stopwatchSvg } from '../../../img/icon/stopwatch-icon.svg';
import imageIcon, { ReactComponent as imageSvg } from '../../../img/icon/image-icon.svg';
import infoIcon, { ReactComponent as infoSvg } from '../../../img/icon/info-icon.svg';
import listIcon, { ReactComponent as listSvg } from '../../../img/icon/list-icon.svg';
import loadingIcon, { ReactComponent as loadingSvg } from '../../../img/icon/loading-icon.svg';
import lockIcon, { ReactComponent as lockSvg } from '../../../img/icon/lock-icon.svg';
import logoutIcon, { ReactComponent as logoutSvg } from '../../../img/icon/logout-icon.svg';
import menuIcon, { ReactComponent as menuSvg } from '../../../img/icon/menu-icon.svg';
import minusIcon, { ReactComponent as minusSvg } from '../../../img/icon/minus-icon.svg';
import notificationIcon, { ReactComponent as notificationSvg } from '../../../img/icon/notification-icon.svg';
import openIcon, { ReactComponent as openSvg } from '../../../img/icon/open-icon.svg';
import plusIcon, { ReactComponent as plusSvg } from '../../../img/icon/plus-icon.svg';
import profileIcon, { ReactComponent as profileSvg } from '../../../img/icon/profile-icon.svg';
import projectIcon, { ReactComponent as projectSvg } from '../../../img/icon/project-icon.svg';
import projectsIcon, { ReactComponent as projectsSvg } from '../../../img/icon/projects-icon.svg';
import projectsIconRed, { ReactComponent as projectsRedSvg } from '../../../img/icon/projects-icon-red.svg';
import projectsDarkIcon, { ReactComponent as projectsDarkSvg } from '../../../img/icon/projects-icon-dark.svg';
import rolesIcon, { ReactComponent as rolesSvg } from '../../../img/icon/roles-icon.svg';
import searchIcon, { ReactComponent as searchSvg } from '../../../img/icon/search-icon.svg';
import settingsIcon, { ReactComponent as settingsSvg } from '../../../img/icon/settings-icon.svg';
import supportIcon, { ReactComponent as supportSvg } from '../../../img/icon/support-icon.svg';
import warningIcon, { ReactComponent as warningSvg } from '../../../img/icon/warning-icon.svg';
import xIcon, { ReactComponent as xSvg } from '../../../img/icon/x-icon.svg';
import arrowRightIcon, { ReactComponent as arrowRightIconSvg } from '../../../img/icon/arrow-right.svg';
import uploadIcon, { ReactComponent as uploadIconSvg } from '../../../img/icon/upload-icon.svg';
import globalSettingsIcon, { ReactComponent as globalSettingsIconSvg } from '../../../img/icon/global-settings.svg';
import companyIcon, { ReactComponent as companyIconSvg } from '../../../img/icon/company-icon.svg';
import deactivatedIcon, { ReactComponent as deactivatedIconSvg } from '../../../img/icon/deactivated-icon.svg';
import bellIcon, { ReactComponent as bellIconSvg } from '../../../img/icon/bell-icon.svg';
import threeDotsIcon, { ReactComponent as threeDotsIconSvg } from '../../../img/icon/three-dots-icon.svg';
import profileIconRed, { ReactComponent as profileRedSvg } from '../../../img/icon/profile-icon-red.svg';
import barrierSystemIcon, { ReactComponent as barrierSystemIconSvg } from '../../../img/icon/barrier-system-icon.svg';
import stopIcon, { ReactComponent as stopIconSvg } from '../../../img/icon/stop-icon.svg';
import tickIcon, { ReactComponent as tickIconSvg } from '../../../img/icon/tick.svg';
import arrowLeftIcon, { ReactComponent as arrowLeftIconSvg } from '../../../img/icon/arrow-left.svg';

export const Icon = {
  arrowLeft: {
    icon: arrowLeftIcon,
    svg: arrowLeftIconSvg
  },
  tick: {
    icon: tickIcon,
    svg: tickIconSvg
  },
  arrowRight: {
    icon: arrowRightIcon,
    svg: arrowRightIconSvg
  },
  alert: {
    icon: alertIcon,
    svg: alertSvg
  },
  arrow: {
    icon: arrowIcon,
    svg: arrowSvg
  },
  calendar: {
    icon: calendarIcon,
    svg: calendarSvg
  },
  cards: {
    icon: cardsIcon,
    svg: cardsSvg
  },
  check: {
    icon: checkIcon,
    svg: checkSvg
  },
  clock: {
    icon: clockIcon,
    svg: clockSvg
  },
  close: {
    icon: closeIcon,
    svg: closeSvg
  },
  cog: {
    icon: cogIcon,
    svg: cogSvg
  },
  correct: {
    icon: correctIcon,
    svg: correctSvg
  },
  delete: {
    icon: deleteIcon,
    svg: deleteSvg
  },
  download: {
    icon: downloadIcon,
    svg: downloadSvg
  },
  edit: {
    icon: editIcon,
    svg: editSvg
  },
  eye: {
    icon: eyeIcon,
    svg: eyeSvg
  },
  file: {
    icon: fileIcon,
    svg: fileSvg
  },
  files: {
    icon: filesIcon,
    svg: filesSvg
  },
  filters: {
    icon: filtersIcon,
    svg: filtersSvg
  },
  image: {
    icon: imageIcon,
    svg: imageSvg
  },
  info: {
    icon: infoIcon,
    svg: infoSvg
  },
  list: {
    icon: listIcon,
    svg: listSvg
  },
  loading: {
    icon: loadingIcon,
    svg: loadingSvg
  },
  lock: {
    icon: lockIcon,
    svg: lockSvg
  },
  logout: {
    icon: logoutIcon,
    svg: logoutSvg
  },
  menu: {
    icon: menuIcon,
    svg: menuSvg
  },
  minus: {
    icon: minusIcon,
    svg: minusSvg
  },
  notification: {
    icon: notificationIcon,
    svg: notificationSvg
  },
  open: {
    icon: openIcon,
    svg: openSvg
  },
  plus: {
    icon: plusIcon,
    svg: plusSvg
  },
  profile: {
    icon: profileIcon,
    svg: profileSvg
  },
  project: {
    icon: projectIcon,
    svg: projectSvg
  },
  projects: {
    icon: projectsIcon,
    svg: projectsSvg
  },
  projectsDark: {
    icon: projectsDarkIcon,
    svg: projectsDarkSvg
  },
  projectsRed: {
    icon: projectsIconRed,
    svg: projectsRedSvg
  },
  roles: {
    icon: rolesIcon,
    svg: rolesSvg
  },
  search: {
    icon: searchIcon,
    svg: searchSvg
  },
  settings: {
    icon: settingsIcon,
    svg: settingsSvg
  },
  stopwatch: {
    icon: stopwatchIcon,
    svg: stopwatchSvg
  },
  support: {
    icon: supportIcon,
    svg: supportSvg
  },
  warning: {
    icon: warningIcon,
    svg: warningSvg
  },
  x: {
    icon: xIcon,
    svg: xSvg
  },
  upload: {
    icon: uploadIcon,
    svg: uploadIconSvg
  },
  globalSettings: {
    icon: globalSettingsIcon,
    svg: globalSettingsIconSvg
  },
  company: {
    icon: companyIcon,
    svg: companyIconSvg
  },
  deactivated: {
    icon: deactivatedIcon,
    svg: deactivatedIconSvg
  },
  bell: {
    icon: bellIcon,
    svg: bellIconSvg
  },
  threeDots: {
    icon: threeDotsIcon,
    svg: threeDotsIconSvg
  },
  profileRed: {
    icon: profileIconRed,
    svg: profileRedSvg
  },
  barrierSystem: {
    icon: barrierSystemIcon,
    svg: barrierSystemIconSvg
  },
  stop: {
    icon: stopIcon,
    svg: stopIconSvg
  }
};
